var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1540_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.66667H6C5.26667 4.66667 4.66667 5.26667 4.66667 6V12.6667C4.66667 13.4 5.26667 14 6 14H12.6667C13.4 14 14 13.4 14 12.6667V6C14 5.26667 13.4 4.66667 12.6667 4.66667ZM12.6667 6.66667C12.6667 7.03333 12.3667 7.33333 12 7.33333H6.66667C6.3 7.33333 6 7.03333 6 6.66667C6 6.3 6.3 6 6.66667 6H12C12.3667 6 12.6667 6.3 12.6667 6.66667ZM8.66667 10V8.66667H10V10H8.66667ZM10 11.3333V12.6667H8.66667V11.3333H10ZM7.33333 10H6V8.66667H7.33333V10ZM11.3333 8.66667H12.6667V10H11.3333V8.66667ZM6 11.3333H7.33333V12.6667H6V11.3333ZM11.3333 12.6667V11.3333H12.6667V12.6667H11.3333ZM4 11.3333H3.33333C2.6 11.3333 2 10.7333 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.7333 2 11.3333 2.6 11.3333 3.33333V4H10V3.33333H3.33333V10H4V11.3333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.1e5fc7d642cef4cb4e1030a0fccce767.svg";
export { ForwardRef as ReactComponent };